export default __webpack_public_path__ + "static/media/potential.90f25b8a.jpg";